import Home from './center-home';
import DocDetails from './doc-details';

export default {
  Home,
  DocDetails
}